import classNames from 'classnames';

import logofts from './logo-fts.svg'
import logot2 from './logo-t2.svg'

import cls from './Header.module.scss'

export const Header = () => (
    <header className={cls.header}>
        <div className={classNames(['content', cls.wrapper])}>
            <img src={logot2} className={cls.logot2} alt={'logo t2'}/>
            <div className={cls.divider}></div>
            <img src={logofts} className={cls.logofts} alt={'logo fts'}/>
        </div>
    </header>
)